import React from "react";
import { Stack, Typography } from "@mui/material";

const PageHeader = ({ title, subtitle, sx = {} }) => {
  return (
    <Stack spacing={0.5} sx={{ mb: 2, ...sx }}>
      <Typography variant="h5">{title}</Typography>
      {subtitle ? (
        <Typography variant="body2" color="text.secondary">
          {subtitle}
        </Typography>
      ) : null}
    </Stack>
  );
};

export default PageHeader;
